import React from 'react';

function LeadStatusBadge({ status }) {
  const statusMap = {
    'New': 'new',
    'Contacted': 'contacted',
    'Qualified': 'qualified',
    'Demo Scheduled': 'demo-scheduled',
    'Demo Completed': 'demo-completed',
    'Won': 'won',
    'Lost': 'lost'
  };

  const className = statusMap[status] || 'new';
  return <span className={`status-badge ${className}`}>{status || 'New'}</span>;
}

export default LeadStatusBadge;